import ToggleAngleIcon from './ToggleAngleIcon.jsx'

export default ToggleAngleIcon
